import {$, $$, getParentElementByTagName} from "./Dom.ts";
import {$get} from "./Ajax.ts";
import {closeActionsMenu} from "./Actions.ts";

export function gererInteractionOnglet(callback : (target: HTMLElement|null) => void, targets: string = '.link_onglet') {
    const ongletsObserverCallback = (mutationList: MutationRecord[]) => {
        for (const mutation of mutationList) {
            if (mutation.type === "attributes") {
                if(mutation.target instanceof HTMLElement) {
                    if(mutation.target.getAttribute("aria-selected") === "true") {
                        callback(mutation.target)
                    }
                }
            }
        }
    }
    const ongletObserver = new MutationObserver(ongletsObserverCallback)
    $$(targets).forEach(element => {
        ongletObserver.observe(element, {
            attributes: true,
            childList: false,
            subtree: false,
            attributeFilter: ['aria-selected'],
            attributeOldValue: false,
            characterData: false,
            characterDataOldValue: false,
        })
    })
}

export function loadPanelContent(tab: HTMLAnchorElement, panel: HTMLElement) {
    return new Promise((resolve, reject) => {
        const url = tab.getAttribute('data-url');
        const isLoaded = tab.getAttribute('data-loaded');
        const targetSelector = tab.getAttribute('data-target');

        // Si le panneau a déjà été chargé, ne rien faire
        if (isLoaded === 'true') {
            reject(new Error("Element already loaded"))
            return;
        }
        if (!url) {
            reject(new Error("No url to load"))
            return;
        }

        // Charger le contenu via AJAX
        $get(url!)
            .then((response) => {
                // Récupérer la cible où insérer le contenu
                let target: HTMLElement | null = null;
                if (targetSelector) {
                    target = $<HTMLElement>(`#${targetSelector}`, panel);
                }
                // Si aucune cible n'existe, insérer directement dans le panneau
                if (!target) {
                    target = panel;
                }
                // Insérer le contenu dans la cible
                if (target) {
                    target.innerHTML = response.body;
                }
                resolve(target)
            })
            .catch((err) => {
                reject(err)
            });
    })
}

export function handleLinkClickToPanel(event: DOMEvent<HTMLElement>) {
    closeActionsMenu()
    event.preventDefault()
    let source = getParentElementByTagName(event.target, 'a')
    const target = $<HTMLElement>(`#menu-${source?.dataset?.target}`)
    target?.click()
}

export function initLinkToOnglet(container: HTMLElement) {
    $$('[data-trigger="tab"]', container).forEach(el => {
        el.addEventListener('click', handleLinkClickToPanel)
    })
}

export function updateMenuInfos() {
    if(!window.Openscop.url_get_menu_data) return

    $get(window.Openscop.url_get_menu_data).then(data => {
        Object.entries(data.body).forEach(([key, value]: [string, unknown]) => {
            const menu = $(`#${key} .menu-info`)
            if (menu) {
                if (Number(value) > 0) menu.innerHTML = `<p class="fr-badge fr-badge--info fr-badge--no-icon">${value}</p>`
                else menu.innerHTML = ""
            }
        })
    }).catch((err) => {
        if(window.Openscop.debug) console.error("error : ", err)
    })
}